import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { MelcoModelsUser } from "melco-shared-logic";
import { Formik } from "formik";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayEditUserForm } from "../form/DisplayEditUserProfileForm";

type UserDetailProfileDrawerProps = {
  isUserProfileDrawerOpen: boolean;
  user: MelcoModelsUser;
  closeAllDrawerAction: () => void;
};

export const UserDetailProfileDrawer: React.FC<
  UserDetailProfileDrawerProps
> = ({ closeAllDrawerAction, isUserProfileDrawerOpen, user: user }) => {
  const { t } = useTranslation();

  const initialValues: MelcoModelsUser = user;

  return (
    <Drawer
      title={t("users.profiledetails.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeAllDrawerAction}
      open={isUserProfileDrawerOpen}
      bodyStyle={{ padding: 10 }}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={() => {}}
        validationSchema={{}}
      >
        <DirtyFormPrompt>
          <DisplayEditUserForm EditFlag={false} />
        </DirtyFormPrompt>
      </Formik>
    </Drawer>
  );
};
